import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "anchorpoint"
    }}>{`AnchorPoint`}</h1>
    <p>{`The reference point on the object's bounding box that does not move during transformation operations. Note: Transformations include rotation, scaling, flipping, and shearing.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_LEFT_ANCHOR`}</strong>{` = 1095660652`}</p>
      <p parentName="blockquote">{`The top left corner.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_CENTER_ANCHOR`}</strong>{` = 1095660643`}</p>
      <p parentName="blockquote">{`The center point on the top of the bounding box.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_RIGHT_ANCHOR`}</strong>{` = 1095660658`}</p>
      <p parentName="blockquote">{`The top right corner.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LEFT_CENTER_ANCHOR`}</strong>{` = 1095658595`}</p>
      <p parentName="blockquote">{`The center point on the left side of the bounding box.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CENTER_ANCHOR`}</strong>{` = 1095656308`}</p>
      <p parentName="blockquote">{`The center point in the bounding box.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RIGHT_CENTER_ANCHOR`}</strong>{` = 1095660131`}</p>
      <p parentName="blockquote">{`The center point on the right side of the bounding box.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BOTTOM_LEFT_ANCHOR`}</strong>{` = 1095656044`}</p>
      <p parentName="blockquote">{`The bottom left corner.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BOTTOM_CENTER_ANCHOR`}</strong>{` = 1095656035`}</p>
      <p parentName="blockquote">{`The center point on the bottom of the bounding box.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`BOTTOM_RIGHT_ANCHOR`}</strong>{` = 1095656050`}</p>
      <p parentName="blockquote">{`The bottom right corner.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      